import { columns } from "../../../../dtos/columns";
import { DividendosTablaDto } from "../models/dividendosTablaForm";

export default function UseColumnasTablaImportacion() {

    const COLUMNS_IMPORTACION: columns<DividendosTablaDto>[] = [
        {
            name: 'Número dividendo',
            selector: (row) => row.numeroDividendo,
            sortable: true,
            sortField: 'numeroDividendo',
            wrap: true,
            export: false,
            center: false,
        },
        {
            name: 'Amortización cuota',
            selector: (row) => row.amortizacionCuota,
            sortable: true,
            sortField: 'amortizacionCuota',
            wrap: true,
            export: false,
            center: false,
        },
        {
            name: 'Interés cuota',
            selector: (row) => row.interesCuota,
            sortable: true,
            sortField: 'interesCuota',
            wrap: true,
            export: false,
            center: false,
        },
        {
            name: 'Dividendo',
            selector: (row) => row.dividendo,
            sortable: true,
            sortField: 'dividendo',
            wrap: true,
            export: false,
            center: false,
        },
        {
            name: 'Capital adeudado',
            selector: (row) => row.capitalAdeudado,
            sortable: true,
            sortField: 'capitalAdeudado',
            wrap: true,
            export: false,
            center: false,
        },
        {
            name: 'Amortización acumulada',
            selector: (row) => row.amortizacionAcumulada,
            sortable: true,
            sortField: 'amortizacionAcumulada',
            wrap: true,
            export: false,
            center: false,
        }
    ]

    return {COLUMNS_IMPORTACION}
}